import { VoidCallback } from '@deqo/foundation';
import React, { useCallback, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { LFC } from '../../../Legacy';
import { ObjectManager } from '../../../concepts/objects';
import { useResolve } from '../../Container';
import { ButtonStrip, Flexer } from '../../dashboard/elements/LayoutElements';
import { Button } from './../../../ui';
import { findAndUpdatePhase, resolveActiveMeetingAndPhase } from './MeetingUtil';
import { SetupPhaseModel } from './SetupPhaseModel';
import { SetupPhaseView } from './SetupPhaseView';

export const ManageActiveMeetingActivityInlineView: LFC<{ onAction: VoidCallback }> = ({ onAction }) => {

    const objects = useResolve(ObjectManager);
    const [model, setModel] = useState<SetupPhaseModel>();

    const onApply = useCallback(() => {
        findAndUpdatePhase(objects, model);
        onAction();
    }, [model, onAction]);

    useEffectOnce(() => {
        const [meeting, phase] = resolveActiveMeetingAndPhase(objects);
        if (meeting && phase) {
            setModel(SetupPhaseModel.createFromExisting(meeting, phase));
        }
    });

    return <Flexer>
        {model && <>
            <SetupPhaseView phase={model} />
            <Flexer padding="0 1 1">
                <ButtonStrip align="right">
                    <Button variant="primary" label="Update" onAction={onApply} />
                    <Button variant="common" label="Cancel" onAction={onAction} />
                </ButtonStrip>
            </Flexer>
        </>}
    </Flexer>;
};
